import { useState, useEffect } from "react";
import FormData from "form-data";
import axios from "axios";
import * as ReactBootStrap from "react-bootstrap";


function Form16() {
    const [cardData, setCardData] = useState({
        Document_type: "",
        Status:"",
        Pan_Number: "",
        Name_of_Employee: "",
        Period_From: "",
        Period_To: "",
        Employee_Address: "",
    });
    const [img, setImg] = useState();
    const [loading , setLoading] = useState(true)

    
    useEffect(() => {
        console.log(cardData);
    }, [cardData]);
    
    const onChange = (e) => {
        var file = e.target.files[0];
        let base64String = "";
        
        var reader = new FileReader();
        console.log("next");
        
        reader.onload = function () {
            base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
            console.log("base64String", base64String);
            setImg("b " + base64String);
        };
        reader.readAsDataURL(file);
    };
    
    const submit = () => {
        setLoading(false);
        setCardData({
            Document_type: "",
            Pan_Number: "",
            Name_of_Employee: "",
            Period_From: "",
            Period_To: "",
            Assesment_Year:"",
            Employee_Address: "",
        });
        var data = new FormData();
        data.append("ImageByte", img);
        var config = {
            method: "post",
            url: "https://xtip5p7c3a.execute-api.ap-south-1.amazonaws.com/default/form16ocrservice",
            headers: {
                "x-api-key": "jCSIISHVNG2e3QLKbX0P82l6LyFM4oLj3mAyUH5R",
                authorizationToken: "arpszfZDmrh3rMJT",
            },
            data: data,
        };
        
        axios(config)
        .then(function (response) {
            console.log(JSON.stringify(response.data));
            setCardData(response.data);
            setLoading(true)
        })
        .catch(function (error) {
            setLoading(true)
            alert("Something went wrong with server");
            console.log(error);
        });
    };
    
    useEffect(() => {}, [cardData]);
    
    return (
        <div>
        <div>
        <div className="container containerBoreder " id="pan">
        <h2 className="pageTitle">Form 16 OCR</h2>
        <div className="row">
            <div className="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div className="col-4">
              <button className="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
        <br />
        <table className="table">
        <tbody>
        <tr>
        <th width="25%">Document Type</th>
        <td>{cardData.Document_Type} </td>
        </tr>
        <tr>
        <th width="25%">Status</th>
        <td>{cardData.Status} </td>
        </tr>
        <tr>
        <th width="25%">Pan Number</th>
        <td>{cardData.Pan_Number} </td>
        </tr>
        <tr>
        <th>Name of Employee</th>
        <td>{cardData.Name_of_Employee}</td>
        </tr>
        <tr>
        <th>Period From</th>
        <td>{cardData.Period_From}</td>
        </tr>
        <tr>
        <th>Period To</th>
        <td>{cardData.Period_To}</td>
        </tr>
        <tr>
        <th>Assesment Year</th>
        <td>{cardData.Assesment_Year}</td>
        </tr>
        <tr>
        <th>Employee Address</th>
        <td>{cardData.Employee_Address}</td>
        </tr>
        </tbody>
        </table>
        </div>
        </div>
        </div>
        );
    }
    
    export default Form16;
    